/*
  TS search popup (B45, 2026-10-23), mockup C1. Loaded (defer) by layout/theme.liquid while Theme settings >
  Search popup (TS) > "Use the TS search popup" is on. Works with sections/predictive-search.liquid,
  snippets/ts-search-pop.liquid, -main, -item and templates/search.ts-pop.liquid.

  1. The theme's SearchBar (theme.js) asks predictive search for 3 products; this raises it to 10, Shopify's maximum,
     so the popup has a best match, its pack or single version and four more matches. Only requests for the
     predictive-search section are touched (window.fetch is wrapped; everything else passes straight through).
  2. Each time the theme draws new results, the product type pills and the total are fetched from the ts-pop search
     view (one request per search, kept for the visit) and added to the popup, up to 6 types, biggest first. The
     store search matches any one word of a several-word search, so for those only types that also appear in the
     popup's own results are kept; a one-word search (a size, a part number) keeps the biggest types as counted.
     No pills when the popup itself found nothing. A pill swaps the main area for that type's results (also from
     the view); All puts the original back.
  3. Quantity buttons and Add to cart on the best match. Add to cart posts to /cart/add.js, closes the search and
     fires the theme's product:added event, so the slide-out cart opens and redraws exactly as after a product page
     Add to cart (gift tiers included).
  4. Sets html.ts-spop-on (wider panel) and, when the layout's script tag has data-ts-spop-dim, html.ts-spop-dim.
*/
(function () {
  'use strict';
  if (window.__tsSpop) return;
  window.__tsSpop = true;

  var root = document.documentElement;
  var me = document.currentScript;
  root.classList.add('ts-spop-on');
  if (me && me.hasAttribute('data-ts-spop-dim')) root.classList.add('ts-spop-dim');

  /* 1. More products from predictive search */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var args = Array.prototype.slice.call(arguments);
      if (typeof input === 'string' && input.indexOf('section_id=predictive-search') !== -1) {
        args[0] = input.replace('resources[limit]=3&', 'resources[limit]=10&');
      }
      return nativeFetch.apply(window, args);
    };
  }

  var routes = window.routes || {};
  var searchUrl = routes.searchUrl || '/search';
  var typesCache = {};
  var mainCache = {};

  function viewUrl(q, type) {
    var u = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&view=ts-pop';
    if (type) u += '&filter.p.product_type=' + encodeURIComponent(type);
    return u;
  }

  function getView(url) {
    return nativeFetch.call(window, url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('ts-pop ' + r.status);
      return r.text();
    }).then(function (text) {
      var d = document.createElement('div');
      d.innerHTML = text;
      return d.querySelector('[data-ts-spop-view]');
    });
  }

  function setAll(pop, href, total) {
    if (href) {
      var links = pop.querySelectorAll('[data-ts-spop-all]');
      for (var i = 0; i < links.length; i++) links[i].setAttribute('href', href);
    }
    var label = pop.querySelector('[data-ts-spop-all-label]');
    if (label) label.textContent = total > 0 ? 'View all ' + total + (total === 1 ? ' result' : ' results') : 'View all results';
  }

  /* Keep the panel inside the screen: the CSS widens it to 760px, this caps it at the right edge. */
  function fit() {
    var inners = document.querySelectorAll('.header .search-bar__inner');
    for (var i = 0; i < inners.length; i++) {
      var form = inners[i].parentElement;
      if (!form) continue;
      var left = form.getBoundingClientRect().left;
      var max = Math.max(280, Math.floor(window.innerWidth - left - 22));
      inners[i].style.setProperty('--ts-spop-max', max + 'px');
    }
  }

  /* 2. Type pills and total */
  function initPopup(pop) {
    if (pop.__tsSpop) return;
    pop.__tsSpop = true;
    var main = pop.querySelector('[data-ts-spop-main]');
    var allMain = pop.querySelector('[data-ts-spop-all-main]');
    pop.__tsMain = main ? main.innerHTML : '';
    pop.__tsAll = allMain ? allMain.getAttribute('href') : '';
    pop.__tsTotal = 0;

    var box = pop.querySelector('[data-ts-spop-types]');
    var q = pop.getAttribute('data-q') || '';
    var shown = parseInt(pop.getAttribute('data-n'), 10) || 0;
    var own = (pop.getAttribute('data-types') || '').split('|').filter(Boolean);
    var oneWord = !/\s/.test(q.trim());
    if (!box || !q || !shown) return;
    var p = typesCache[q] || (typesCache[q] = getView(viewUrl(q)));
    p.then(function (view) {
      if (!view || !pop.isConnected) return;
      var total = parseInt(view.getAttribute('data-total'), 10) || 0;
      pop.__tsTotal = total;
      setAll(pop, '', total);
      var types = view.querySelector('[data-ts-spop-types]');
      if (!types) return;
      var kept = 0;
      var pills = types.querySelectorAll('[data-ts-spop-type]');
      for (var i = 0; i < pills.length; i++) {
        var t = pills[i].getAttribute('data-ts-spop-type');
        if (!t) continue;
        if (kept < 6 && (oneWord || own.indexOf(t) !== -1)) kept++;
        else pills[i].parentNode.removeChild(pills[i]);
      }
      if (kept < 2) return;
      box.innerHTML = types.innerHTML;
      box.hidden = false;
      pillsMore(box);
    }).catch(function () { delete typesCache[q]; });
  }

  /* Fade the pill row's right edge while pills are hidden past it. */
  function pillsMore(box) {
    box.classList.toggle('is-more', box.scrollLeft + box.clientWidth < box.scrollWidth - 2);
  }

  function pickType(btn) {
    var pop = btn.closest('[data-ts-spop]');
    if (!pop) return;
    var type = btn.getAttribute('data-ts-spop-type') || '';
    var q = pop.getAttribute('data-q') || '';
    var pills = pop.querySelectorAll('[data-ts-spop-type]');
    for (var i = 0; i < pills.length; i++) {
      var on = pills[i] === btn;
      pills[i].classList.toggle('is-active', on);
      pills[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var main = pop.querySelector('[data-ts-spop-main]');
    if (!main) return;
    if (!type) {
      main.classList.remove('is-loading');
      main.innerHTML = pop.__tsMain;
      setAll(pop, pop.__tsAll, pop.__tsTotal);
      return;
    }
    var countEl = btn.querySelector('.ts-spop__pill-n');
    var count = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
    var key = q + '\u0001' + type;
    main.classList.add('is-loading');
    var p = mainCache[key] || (mainCache[key] = getView(viewUrl(q, type)));
    p.then(function (view) {
      if (!pop.isConnected || !btn.classList.contains('is-active')) return;
      main.classList.remove('is-loading');
      var m = view && view.querySelector('[data-ts-spop-main]');
      if (m) main.innerHTML = m.innerHTML;
      setAll(pop, view ? view.getAttribute('data-all') : '', count);
    }).catch(function () {
      delete mainCache[key];
      main.classList.remove('is-loading');
    });
  }

  /* 3. Quantity and Add to cart */
  function stepQty(btn) {
    var item = btn.closest('[data-ts-spop-item]');
    var input = item && item.querySelector('[data-ts-spop-qty]');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + (parseInt(btn.getAttribute('data-ts-spop-step'), 10) || 0);
    input.value = Math.min(999, Math.max(1, v));
  }

  function closeSearch(from) {
    var wrap = from.closest('.header__search-bar-wrapper');
    if (!wrap) return;
    if (window.matchMedia('(max-width: 640px)').matches) {
      var close = wrap.querySelector('[data-action="unfix-search"]');
      if (close) { close.click(); return; }
    }
    var input = wrap.querySelector('[name="q"]');
    var bar = wrap.querySelector('.search-bar');
    var results = wrap.querySelector('.search-bar__results');
    if (input) input.blur();
    wrap.classList.remove('is-fixed');
    if (bar) bar.classList.remove('is-expanded');
    if (results) results.setAttribute('aria-hidden', 'true');
  }

  function showMsg(item, text) {
    var msg = item && item.querySelector('[data-ts-spop-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var item = btn.closest('[data-ts-spop-item]');
    var input = item && item.querySelector('[data-ts-spop-qty]');
    var qty = Math.min(999, Math.max(1, parseInt(input && input.value, 10) || 1));
    var id = parseInt(btn.getAttribute('data-ts-spop-add'), 10);
    if (!id) return;
    var msg = item && item.querySelector('[data-ts-spop-msg]');
    if (msg) msg.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-busy');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    nativeFetch.call(window, (routes.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      btn.disabled = false;
      btn.classList.remove('is-busy');
      if (!res.ok) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        showMsg(item, (res.data && (res.data.description || res.data.message)) || 'Could not add this to the cart.');
        return;
      }
      var theme = window.theme || {};
      if (theme.pageType === 'cart' || theme.cartType === 'page') {
        window.location.href = routes.cartUrl || '/cart';
        return;
      }
      closeSearch(btn);
      btn.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: btn, variant: null, quantity: qty, productAdded: true }
      }));
    }).catch(function () {
      btn.disabled = false;
      btn.classList.remove('is-busy');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      showMsg(item, 'Could not add this to the cart. Please try again.');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-ts-spop-type]');
    if (b) { e.preventDefault(); pickType(b); return; }
    b = t.closest('[data-ts-spop-step]');
    if (b) { e.preventDefault(); stepQty(b); return; }
    b = t.closest('[data-ts-spop-add]');
    if (b) { e.preventDefault(); addToCart(b); }
  });

  /* Enter in the quantity box adds to the cart instead of submitting the search form. */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key !== 'Enter' || !t || !t.matches || !t.matches('[data-ts-spop-qty]')) return;
    e.preventDefault();
    var item = t.closest('[data-ts-spop-item]');
    var b = item && item.querySelector('[data-ts-spop-add]');
    if (b) addToCart(b);
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ts-spop-types]')) pillsMore(t);
  }, true);

  /* A mouse wheel over the pill row scrolls it sideways. */
  document.addEventListener('wheel', function (e) {
    var box = e.target && e.target.closest && e.target.closest('[data-ts-spop-types]');
    if (!box || box.scrollWidth <= box.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    e.preventDefault();
    box.scrollLeft += e.deltaY;
  }, { passive: false });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ts-spop-qty]')) t.value = t.value.replace(/[^0-9]/g, '').slice(0, 3);
  });

  /* Watch the theme's results box for new results. */
  function watch() {
    var boxes = document.querySelectorAll('.search-bar__results-inner');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        if (box.__tsSpopWatch) return;
        box.__tsSpopWatch = true;
        new MutationObserver(function () {
          var pop = box.querySelector('[data-ts-spop]');
          if (pop) { fit(); initPopup(pop); }
        }).observe(box, { childList: true });
      })(boxes[i]);
    }
  }

  function start() {
    watch();
    fit();
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('.search-bar__input')) fit();
    });
    window.addEventListener('resize', fit);
    document.addEventListener('shopify:section:load', watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
